import { TrackServiceType } from "./TrackFinancialModels";
import { Country, TrackReleaseSet, TrackServiceModel } from "../../../../../api/useMusicApi";
import { useTranslation } from "../../../../../hooks/useTranslation";
import cn from "classnames";
import { LabelHint } from "../../../../../components/LabelHint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import _ from "lodash";
import React from "react";

type Props = {
  item: TrackServiceType;
  service: TrackServiceModel | null;
  isActive: boolean;
  onChangeActive: () => void;
  onChangeForAll: (field: keyof TrackReleaseSet, value: any) => void;
};

export const TrackFinancialModelServiceSelector: React.FC<Props> = ({
                                                                      item,
                                                                      service,
                                                                      isActive,
                                                                      onChangeActive,
                                                                      onChangeForAll
                                                                    }) => {
  const { t } = useTranslation();
  const title = [];
  const meaningFullCountries = Object.keys(service?.countries ?? {}).filter(
    (key) => !_.isEmpty(service?.countries[key as keyof typeof Country])
  );

  if (meaningFullCountries.includes(Country.ALL)) {
    title.push(t("all_world"));
  }

  if (
    meaningFullCountries.length === 1 &&
    meaningFullCountries[0] !== Country.ALL
  ) {
    title.push(t(meaningFullCountries[0]));
  }

  if (meaningFullCountries.length > 1) {
    title.push(t("some_countries"));
  }

  return (
    <div
      className={cn("flex justify-between cursor-pointer rounded p-2", {
        "bg-blue-500 text-white": isActive,
        "hover:bg-gray-100": !isActive
      })}
      style={{ width: 180, height: 55 }}
      onClick={onChangeActive}
    >
      <div>
        <div className={"flex gap-1 align-items-center"}>
          <LabelHint
            className={cn("inline-flex text-xs", {
              "text-muted": !isActive,
              "text-white hover:text-black": isActive
            })}
            iconClassName={cn({
              "text-muted": !isActive,
              "text-white hover:text-black": isActive
            })}
            hint={t(`${item}_hint`)}
          />
          <div className={cn("font-bold")}>{t(item)}</div>
        </div>
        <div
          className={cn({
            "text-muted": !isActive,
            "text-white hover:text-black": isActive
          })}
          style={{ fontSize: 12 }}
        >
          {title.join(", ")}
        </div>
      </div>
      <div className={"ml-1"}>
        <FontAwesomeIcon
          icon={faChevronRight}
          size={"xs"}
          className={cn({
            "text-muted": !isActive,
            "text-white": isActive
          })}
        />
      </div>
    </div>
  );
};
